import {Button, Form} from "semantic-ui-react"
import * as React from "react"
import {InvoiceByNumber} from "../graphql/queries"
import {errorUnionToEither, newError} from "../graphql/errors"
import {left, right} from "fp-ts/lib/Either"
import {history, WithModalStore} from "../App"
import {GraphQL} from "../graphql"

interface State {
  invoiceNumber: string
}

export class ViewInvoiceForm extends React.Component<WithModalStore, State> {
  constructor(props: WithModalStore) {
    super(props)
    this.state = {invoiceNumber: ""}
  }

  render() {
    return (
      <Form>
        <Form.Field>
          <label>View Invoice</label>
          <Form.Group>
            <Form.Input
              placeholder="Invoice Number"
              value={this.state.invoiceNumber}
              onChange={(e, x) => {
                e.preventDefault()
                this.setState({invoiceNumber: x.value})
              }}
            />
            <Button
              disabled={this.state.invoiceNumber.trim().length === 0}
              onClick={() => {
                this.props.modalStore.handlePromiseThrow(
                  this.onInvoiceNumber(this.state.invoiceNumber),
                )
              }}
            >
              View
            </Button>
          </Form.Group>
        </Form.Field>
      </Form>
    )
  }

  async onInvoiceNumber(invoiceNumber: string) {
    await this.props.modalStore.applyModal({
      error: (m) => ["Failed to retrieve invoice", m],
      async action() {
        const {invoiceByNumber: invoice} = await GraphQL.query(
          InvoiceByNumber,
          {number: invoiceNumber},
          {noCache: true},
        )
        return errorUnionToEither(invoice).chain((invoice) => {
          if (!invoice.xeroInvoiceReady) {
            return left(newError(`Invoice "${invoiceNumber}" is still being prepared`))
          } else {
            history.push("/invoice/" + invoice.id)
            return right(undefined)
          }
        })
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/ViewInvoiceForm.tsx